import { HeaderProvider } from '@/components/context/HeaderContext';
import { DashboardLayoutContent } from './DashboardLayoutContent';

export function DashboardLayout() {
  return (
    <HeaderProvider>
      <DashboardLayoutContent />
    </HeaderProvider>
  );
}
